<template>
  <a-card>
    <template v-slot:title>
      Create Disbursement
    </template>

    <a-row>
      <a-col :span="12">
        <a-form-model :model="formData" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
          <a-form-model-item :label-col="{span: 8}" :wrapper-col="{ span: 12 }" label="Disbursement Tipe" prop="type">
            <a-input placeholder="Disbursement Tipe" :value="disbursementType.toUpperCase() " readOnly>
              <a-icon slot="prefix" type="highlight" style="color: rgba(0,0,0,0.25)"/>
            </a-input>
          </a-form-model-item>
          <a-form-model-item :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }" label="Hari">
            <a-radio-group name="day" v-model="formData.day" @change="onChangeDay">
              <a-radio value="full">
                Full Day
              </a-radio>
              <a-radio value="half">
                Half Day
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="Tanggal Awal" prop="reconcile_start_date">
            <a-row type="flex" :gutter="8">
              <a-col :span="12">
                <a-date-picker
                    v-model="formData.reconcile_start_date"
                    @change="onStartDateChange"
                    :format="'YYYY-MM-DD'"
                    type="date"
                    placeholder="Pick a date"
                />
              </a-col>
              <a-col :span="12" v-if="formData.day == 'half'">
                <a-select v-model="formData.hour" @change="handleChange">
                  <a-select-option value="morning">
                    00:00 - 12:00 (H+0)
                  </a-select-option>
                  <a-select-option value="noon">
                    12:01 - 23:59 (H+1)
                  </a-select-option>
                </a-select>
              </a-col>
            </a-row>
          </a-form-model-item>
          <a-form-model-item label="Tanggal Akhir" prop="reconcile_end_date" v-if="formData.day == 'full'">
            <a-date-picker
                v-model="formData.reconcile_end_date"
                @change="onEndDateChange"
                :format="'YYYY-MM-DD'"
                type="date"
                placeholder="Pick a date"
            />
          </a-form-model-item>
          <a-form-model-item label="Biller" prop="biller">
            <biller-autocomplete style="width: 100%" @change="(item) => autocomplete(item) "/>
          </a-form-model-item>
          <a-form-model-item label="Product Group" prop="product_group">
            <group-autocomplete style="width: 100%" @change="(item) => autocompleteProductGroup(item) "/>
          </a-form-model-item>
          <a-form-model-item label="Product" prop="product">
            <product-autocomplete style="width: 100%" @change="(item) => autocompleteProduct(item) "/>
          </a-form-model-item>
          <a-form-model-item label="Sponsor" prop="sponsor" v-if="disbursementType == 'sponsor_profit'">
            <sponsor-select @change="onSponsorChange"></sponsor-select>
          </a-form-model-item>
          <a-form-model-item :label-col="{span: 8}" :wrapper-col="{ span: 12 }" label="Remark 1" prop="remark_1">
            <a-input placeholder="Remark 1" v-model="formData.remark_1">
              <a-icon slot="prefix" type="bank" style="color: rgba(0,0,0,0.25)"/>
            </a-input>
          </a-form-model-item>
          <a-form-model-item :label-col="{span: 8}" :wrapper-col="{ span: 12 }" label="Remark 2" prop="remark_2">
            <a-input placeholder="Remark 2" v-model="formData.remark_2">
              <a-icon slot="prefix" type="bank" style="color: rgba(0,0,0,0.25)"/>
            </a-input>
          </a-form-model-item>
          <a-form-model-item :label-col="{span: 8}" :wrapper-col="{ span: 12 }" label="Remark 3" prop="remark_3">
            <a-input placeholder="Remark 3" v-model="formData.remark_3">
              <a-icon slot="prefix" type="bank" style="color: rgba(0,0,0,0.25)"/>
            </a-input>
          </a-form-model-item>
          <a-form-model-item>
              <a-row type="flex" justify="center" align="top">
                  <a-col>
                    <a-popconfirm :title="'Are you sure you want to create disbursement ' + disbursementType.toUpperCase()" @confirm="handleSubmit">
                    <a-button
                        type="primary"
                        html-type="submit"
                        :loading="loading"
                        :disabled="loading"
                        >Submit</a-button>
                    </a-popconfirm>
                  </a-col>
              </a-row>
          </a-form-model-item>
        </a-form-model>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
export default {
  name: "create-disbursement",
  data() {
    return {
      loading: false,
      formData: {
        day: 'full',
      },
    }
  },
  computed: {
    disbursementType() {
      let urlParams = new URLSearchParams(window.location.search)

      return urlParams.get('type')
    }
  },
  methods: {
    autocomplete(v) {
      if (v.length === 0) {
        this.formData.biller = ""
      } else {
        this.formData.biller = _.map(v, (o) => o.id)[0]
      }
    },
    autocompleteProductGroup(v) {
      if (v.length === 0) {
        this.formData.product_groups = []
      } else {
        this.formData.product_groups = _.map(v, (o) => o.name)
      }
    },
    autocompleteProduct(v) {
      if (v.length === 0) {
        this.formData.products = []
      } else {
        this.formData.products = _.map(v, (o) => o.id)
      }
    },
    onSponsorChange(data) {
      this.formData.sponsor = data.hash
    },
    onStartDateChange(date, dateString) {
        this.formData.reconcile_start_date = dateString
    },
    onEndDateChange(date, dateString) {
        this.formData.reconcile_end_date = dateString
    },
    handleSubmit(e) {
        this.loading = true;

        let promise;

        this.formData.type = this.disbursementType

        promise = this.$http.post(
            this.routeUri("hyperion.transaction.amount.disbursement"),
            this.formData
        );

        promise
            .then(response =>
                this.handleSuccessResponse(response.data)
            )
            .catch(err => this.handleXhrError(err))
            .finally(() => (this.loading = false));
    },
    handleSuccessResponse(data) {
      this.$notification.success({
        message: "Success",
        description: "You will be redirected in a few moment."
      })

      setTimeout(() => window.location.href = this.routeUri("hyperion.transaction.disbursement"), 3000)
    },
    onChangeDay(e) {
      this.formData.day = e.target.value;

      if(e.target.value == 'full'){
        delete this.formData['hour']
      }else{
        delete this.formData['reconcile_end_date']
      }
    },
    handleChange(value) {
      this.formData.hour = value
    },
  }
}
</script>

<style scoped>

</style>
